
<template>

<el-row>
    <el-col :span="18">

        <el-form :model="productForm" addAction="lcwpgoods/addGoods.action" selectAction="lcwpgoods/selectGoodsInfo.action" editAction="lcwpgoods/editGoods.action"  v-form :rules="rules" ref="ruleForm" label-width="150px">

            <el-form-item label="商品名称" prop="goodsName" >
                <el-input v-model="productForm.goodsName" placeholder="请填写（20字以内）"></el-input>
            </el-form-item>

            <el-form-item label="商品描述" prop="goodsDesc">
                <el-input v-model="productForm.goodsDesc" type="textarea" placeholder="必填 比如：仅售99元，价值240元德系车专享，免擦护理洗车+打蜡，节假日通用，来店之前请电话咨询，方便我们为你安排师傅，节省您的宝贵时间"></el-input>
            </el-form-item>
          <el-form-item label="封面图片" prop="imgLink">
            <el-upload
                multiple
                :limit="1"
                ref="imgLink"
                :http-request="onHttpRequest"
                accept="image/*"
                action="upload/uploadPic"
                v-model="productForm.imgLink"
                :before-upload="beforeAvatarUpload"
                :data="{floder:'vip-bus'}"
                list-type="picture-card"
                :file-list="productForm.imgLink">
              <i class="el-icon-plus"></i>
            </el-upload>
            <p style="color:red;">图片尺寸：750*750像素，最多1张</p>
          </el-form-item>
            <el-form-item label="详情图片" prop="descImgs">
              <el-upload
                  multiple
                  ref="descImgs"
                  :http-request="onHttpRequest"
                  accept="image/*"
                  action="upload/uploadPic"
                  v-model="productForm.descImgs"
                  :before-upload="beforeAvatarUpload"
                  :data="{floder:'vip-bus'}"
                  list-type="picture-card"
                  :limit="9"
                  :file-list="productForm.descImgs">
                  <i class="el-icon-plus"></i>
              </el-upload>
              <p style="color:#666;"><span style="color:red;">图片尺寸：750*460像素，最多9张</span></p>
            </el-form-item>

          <el-form-item label="原价" prop="currentPrice">
            <el-input type="number"  v-model="productForm.currentPrice" placeholder="可输入两位小数"></el-input>
          </el-form-item>
          <el-form-item  label="会员价" prop="vipPrice">
            <el-input type="number"  v-model="productForm.vipPrice" placeholder="可输入两位小数"></el-input>
          </el-form-item>
          <el-form-item  label="库存数量" prop="stockCount">
            <el-input type="number"  v-model="productForm.stockCount" placeholder="请输入正整数"></el-input>
          </el-form-item>
          <el-form-item  label="每人限购" prop="limitedQuantity">
            <el-input type="number"  v-model="productForm.limitedQuantity" placeholder="请输入正整数，0表示不限制"></el-input>
          </el-form-item>
          <el-form-item  label="绿豆抵扣" prop="maxMungBean">
            <el-input type="number"  v-model="productForm.maxMungBean" placeholder="请输入正整数，0表示不支持用绿豆抵扣（10绿豆=1元）"></el-input>
          </el-form-item>

            <el-form-item>
                <el-button type="primary">确定发布</el-button>
            </el-form-item>

        </el-form>

    </el-col>
</el-row>

</template>

<script>

import ChannelModel from '@/framework/models/channelModel'
import BrandAndSeriesSelect from '@/components/BrandAndSeriesSelect'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
import addPlusNewCar from './addPlusNewCar'
export default {
  name: 'add-thematic-dialog',
  extends: BasicPager,
  data: function () {
    var checkPrice = (rule, value, callback) => {
      if (value <= 0) {
        return callback(new Error('金额不能小于等于0'))
      }
      callback()
    }

    return {
      tips: '提示：该类商品只用于发布后展示，暂不支持用户直接线上下单支付',
      placeholder: '比如：埃尔法热销中 目前售价77.2万元起；近日，本店内有埃尔法销售，颜色可选，目前购车部分车型可优惠6.8万元，感兴趣的朋友可以到店咨询购买',
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      productForm: {
        type: '新车',
        productInfo: null,
        seriesId: null,
        brandId: null,
        seriesName: null,
        productName: null,
        priceInfo: null,
        rushToBuy: 0,
        imgLink: [],
        descImgs: [],
        businessId: null,
        originalPrice: null,
        vipPrice: null,
        currentPrice: null,
        stockCount: null,
        limitedQuantity: null,
        maxMungBean: null
      },
      rules: {
        goodsName: [{
          required: true,
          message: '商品名称不能为空'
        }, { type: 'string', required: true, max: 100, message: '最多100个汉字' }],
        goodsDesc: [{
          required: true,
          message: '商品描述不能为空'
        }],
        originalPrice: [{
          required: true,
          message: '价格不能为空！'
        }, {
          validator: checkPrice, trigger: 'blur'
        }],

        currentPrice: [{
          required: true,
          message: '价格不能为空！'
        }, {
          validator: checkPrice, trigger: 'blur'
        }],
        imgLink: [
          {
            required: true,
            message: '封面图不能为空！',
            trigger: 'change'
          }
        ],
        descImgs: [
          {
            required: true,
            message: '详情图片不能为空！',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    'productForm.productType': function (productType) {
      this.productForm.brandId = null
      this.productForm.seriesId = null
      this.productForm.seriesName = null
      this.productForm.productName = null
      this.productForm.imgLink = []
      this.$refs['brand-and-series-select'].clear()
    },
    'productForm.type': function (newVlue) {
      let that = this
      switch (newVlue) {
        case '新车':that.placeholder =
            '比如：埃尔法热销中 目前售价77.2万元起；近日，本店内有埃尔法销售，颜色可选，目前购车部分车型可优惠6.8万元，感兴趣的朋友可以到店咨询购买'
          that.tips = '提示：该类商品只用于发布后展示，暂不支持用户直接线上下单支付'

          break
        case '二手车':
          that.placeholder = '比如：本车于xx年xx月上牌；xx地方的牌照；行驶里程xx万公里；平时都在4S店保养，无事故、轻微剐蹭过，保险事项；'

          that.tips = '提示：该类商品只用于发布后展示，暂不支持用户直接线上下单支付'

          break

        default:
          that.placeholder = '比如：仅售99元，价值240元德系车专享，免擦护理洗车+打蜡，节假日通用，来店之前请电话咨询，方便我们为你安排师傅，节省您的宝贵时间'
          that.tips = '提示：该类商品支持用户按照【现价】线上下单支付'
      }
    }

  },
  components: {
    BrandAndSeriesSelect,
    addPlusNewCar
  },
  created: function () {
    let params = this.$route.params

    this.productForm.id = params.goodsId

    if (params.type) {
      this.productForm.type = params.type
    }

    if (params.businessId) {
      let businessId = parseInt(params.businessId)
      this.productForm.businessId = businessId
    }

    if (params.carShowId) {
      this.productForm.carShowId = params.carShowId
    }
  },
  methods: {
    onTypeChange: function () {
      this.productForm.imgLink = []
    },
    onSelectInfo: function (dataInfo) {
      this.productForm.currentPrice = (dataInfo.datas.currentPrice / 100) + ''
      this.productForm.vipPrice = (dataInfo.datas.vipPrice / 100) + ''

      if (dataInfo.datas.originalPrice) {
        this.productForm.originalPrice = (dataInfo.datas.originalPrice / 100) + ''
      } else {
        this.productForm.originalPrice = this.productForm.currentPrice
      }
    },
    carCategoryChange: function (brandInfo, seriesInfo) {
      this.productForm.brandId = brandInfo.id
      this.productForm.brand = brandInfo.name
      this.productForm.productName = seriesInfo.name
      this.productForm.imgLink = []

      this.productForm.goodsName = brandInfo.name + ' ' + seriesInfo.name

      this.productForm.seriesId = seriesInfo.id

      // 添加照片
      if (this.productForm.type == '新车') {
        let name = seriesInfo.imgUrl.replace('https://csz-test.oss-cn-hangzhou.aliyuncs.com/', '').replace('https://csz-public.oss-cn-hangzhou.aliyuncs.com/', '')
        this.productForm.imgLink.push({
          name: name,
          url: seriesInfo.imgUrl
        })

        if (!seriesInfo) {
          this.productForm.imgLink = []
          return
        }
      }

      this.productForm.series = seriesInfo.name
    },

    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }

        if (_this.productForm.imgLink.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.components[2].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    },
    onFilterParams: function (params) {
      params.currentPrice = parseInt(params.currentPrice * 100)
      params.vipPrice = parseInt(params.vipPrice * 100)
      if (params.originalPrice) {
        params.originalPrice = parseInt(params.originalPrice * 100)
      } else {
        params.originalPrice = params.currentPrice
      }

      // }
    }
  }
}

</script>
